import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import ERPDashboard from 'images/ERPDashboard.png';
export default function LoginDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('erpDashboardText', { ns: ['home'] })}</Typography>
      <img src={ERPDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
